<script lang="ts" setup>
defineSlots<{
  default: () => VNode[];
}>();
</script>

<template>
  <div class="contentCollapseList">
    <slot />
  </div>
</template>

<style lang="scss">
.contentCollapseList {
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-bottom: 40px;
}
</style>
